import React from "react";

import Layout from "../components/Layout";
import SEO from "../components/SEO";

function PricingPage() {
  return (
    <Layout>
      <SEO title="Pricing"
      />

      <section className="w-full px-4 sm:max-w-6xl mx-auto py-16">
        <h1 className="text-3xl leading-tight font-extrabold text-gray-900 sm:text-4xl text-center">Pricing</h1>
        <p className="my-12 text-gray-800 sm:text-lg md:text-xl">
          Our standard package is priced based on the fact that final projects will follow certain layout and styling patterns as seen in
          the Showcase section. By having an opinionated solution, we can lower our costs and pass the savings onto you.
        </p>

        <div className="mt-6 text-gray-800">
          <h2 className="text-xl font-bold">Basic Package - $997</h2>
          <ul className="py-4 list-disc text-lg">          
            <li className="py-1 ml-4">Done for you Landing Page</li>
            <li className="py-1 ml-4">Brand and content strategy consultation</li>
            <li className="py-1 ml-4">3 basic pages excluding landing (About etc)</li>
            <li className="py-1 ml-4">Email capture form with integration</li>
            <li className="py-1 ml-4">Contact form with integration</li>
            <li className="py-1 ml-4">Style guide</li>
            <li className="py-1 ml-4">Live site link + 1 Month Hosting on Netlify (can upgrade to continue)</li>
            <li className="py-1 ml-4">Github repo of code</li>
          </ul>
        </div>

        <div className="mt-6 text-gray-800">
          <h2 className="text-xl font-bold">Add Ons</h2>
          <ul className="py-4 list-disc text-lg">
            <li className="py-1 ml-4">Extra basic page - <span className="font-semibold">$50</span></li>
            <li className="py-1 ml-4">Google Analytics - <span className="font-semibold">$50</span></li>
            <li className="py-1 ml-4">Terms of Service - <span className="font-semibold">$50</span></li>
            <li className="py-1 ml-4">Privacy Policy - <span className="font-semibold">$50</span></li>
          </ul>
        </div>  

        <div className="mt-6 text-gray-800">
          <h2 className="text-xl font-bold">Advanced (custom priced)</h2>
          <ul className="py-4 list-disc text-lg">
            <li className="py-1 ml-4">Content Management System (Blog)</li>
            <li className="py-1 ml-4">Authentication</li>
            <li className="py-1 ml-4">Restricted Routes</li>
            <li className="py-1 ml-4">Stripe Integration</li>
          </ul>
        </div>                

      </section>
    </Layout>
  );
}

export default PricingPage;        